export const RAIN_NUM = 350
export const LIGHTNING_INTERVAL = 5000
